import type { RouteObject } from "react-router-dom";
import SiteLayout from "../components/feature/SiteLayout";
import Home from "../pages/home/page";
import Brand from "../pages/brand/page";
import News from "../pages/news/page";
import Products from "../pages/products/page";
import Detail from "../pages/detail/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "brand", element: <Brand /> },
      { path: "news", element: <News /> },
      { path: "products", element: <Products /> },
      { path: "detail/:id", element: <Detail /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;